<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="subscribe()">
      <v-icon color="blue darken-4">subscriptions</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String
  },
  methods: {
    subscribe() {
      this.$emit("subscribe");
    }
  }
};
</script>

<style>
</style>
